import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=06c79e74&"
import script from "./UploadImage.vue?vue&type=script&lang=js&"
export * from "./UploadImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/agent_ai/agent-ai-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c79e74')) {
      api.createRecord('06c79e74', component.options)
    } else {
      api.reload('06c79e74', component.options)
    }
    module.hot.accept("./UploadImage.vue?vue&type=template&id=06c79e74&", function () {
      api.rerender('06c79e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/UploadImage.vue"
export default component.exports